import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { compose, RewardTypes } from '../../../../services/utilityFunctions';
import translate from '../../../translate';
import withCSRF from '../../../withCSRF';
import Carousel from '../../../carousel/Carousel';
import Notifications from '../../../../services/notifications';
import ReactLoader from '../../../loader/ReactLoader';
import RewardCardItem from '../../../rewards/RewardCardItem';

const getPosition = itemId => {
  let position;
  switch (itemId) {
    case RewardTypes.COMMISSION:
      position = 10;
      break;
    case RewardTypes.WALLET_BALANCE:
      position = 15;
      break;
    case RewardTypes.COINS:
      position = 20;
      break;
    case RewardTypes.CHARITY_COINS:
      position = 30;
      break;
    case RewardTypes.COUPONS:
      position = 40;
      break;
    case RewardTypes.VOUCHERS:
      position = 50;
      break;
    default:
      position = Math.floor(
        Math.random() * (Math.floor(12) - Math.ceil(5)) + Math.ceil(6),
      );
      break;
  }
  return position;
};

const RewardsList = () => {
  const [rewardsList, setRewardsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getUserRewards = () => {
    axios
      .get('/api/wallet/totals', {
        headers: {
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Games',
        },
      })
      .then(({ data: response }) => {
        const rewardsArray = Object.entries(response.data).map(resp => ({
          position: getPosition(resp[0]),
          _id: resp[0],
          value: resp[1],
          currency: response.data[RewardTypes.COMMISSION_CURRENCY],
        }));
        const rewardsFiltered = rewardsArray.filter(
          reward =>
            reward._id !== RewardTypes.COMMISSION_CURRENCY &&
            reward._id !== RewardTypes.COMMISSION_VA,
        );
        setRewardsList(rewardsFiltered.sort((a, b) => a.position - b.position));
        setIsLoading(false);
      })
      .catch(err => {
        Notifications.showErrorFromRequest(err, 'error_fetchCourse');
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getUserRewards();
  }, []);

  return (
    <ReactLoader isLoading={isLoading}>
      <Carousel>
        {rewardsList.map(item => (
          <RewardCardItem key={item._id} item={item} />
        ))}
      </Carousel>
    </ReactLoader>
  );
};

export default compose(translate, withCSRF)(RewardsList);
